var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('div',[(_vm.form)?_c('div',[_c('module-view-form',{attrs:{"id":_vm.item.formId,"moduleId":_vm.moduleId,"itemId":_vm.id}})],1):_c('div',[_c('module-view-bi',{attrs:{"id":_vm.item.powerBiViewId}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }